import { Button, Grid, Typography } from "@mui/material";
import { GadgetIcon } from "../../Home/components/gadgets/GadgetIcon";
import { FlattenedGadget } from "../../../models/GadgetModel";
import { MouseEventHandler, useState } from "react";
import styles from "../css/GadgetDetailsTopSection.module.css";
import { InstallButton } from "./InstallButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { update } from "../../../common/state/Slices/HeaderMenuSlice";
import { Routes } from "../../../routes/routes";

interface GadgetDetailsTopSectionProps {
    displayGadget: FlattenedGadget,
    iconFile: string,
    handleOpenModal: MouseEventHandler,
    handleGadgetDownload: MouseEventHandler
}

export const GadgetDetailsTopSection = ({iconFile, displayGadget, handleOpenModal, handleGadgetDownload}: GadgetDetailsTopSectionProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showMore, setShowMore] = useState<boolean>(false);
  const shouldShowMore = displayGadget?.description.length >= 150;
  const handleBck = () => {
    dispatch(
      update({
        selectedMenu: Routes.HOME,
      })
    );
    navigate(-1);
  }

    return (
        <Grid container sx={{mt: "3rem"}}>
          <Button 
            data-testid="back-btn"
            size="large"
            onClick={handleBck}
            className={styles.backButton} 
            startIcon={<FontAwesomeIcon icon={faArrowLeftLong} />}
          >
              <h2>Back</h2>
          </Button>
          <Grid item xs={3} className={styles.imageContainer}>
            <GadgetIcon image={iconFile} altText="Gadget icon" styles={{ width: 200, borderRadius: 5}} dataTestId="gadget-icon" />
          </Grid>
          <Grid item xs={6} className={styles.gridItem}>
            <div>
              <Typography variant="h2" sx={{fontWeight: "bold", margin: "1rem 0"}}>{displayGadget?.name}</Typography> 
              <Typography variant="body2" className={styles.gadgetDescriptionText} data-testid="gadget-description">
                {
                  showMore ? displayGadget?.description : displayGadget?.description.substring(0, 150)
                }
                {
                  shouldShowMore
                  && 
                  <Button onClick={() => setShowMore(!showMore)} variant="text" className={styles.showMoreBtn}>
                    {showMore ? "Show Less" : "Show More"}
                  </Button>
                }
              </Typography>
            </div>
          </Grid>
          <Grid item xs={3} className={styles.buttonContainer}>
              <InstallButton handleOpenModal={handleOpenModal} handleGadgetDownload={handleGadgetDownload} />
          </Grid>
        </Grid>
    )
}